import {
    AddinsFlexPaneBody as LazyAddinsFlexPaneBody,
    AddinsFlexPaneHeader as LazyAddinsFlexPaneHeader,
} from 'owa-addins-view';
import getDrawerPaneId from 'owa-app-pane-group-utils/lib/getDrawerPaneId';
import { DrawerPane } from 'owa-drawer';
import { observer } from 'owa-mobx-react';
import getModuleContextMailboxInfo from 'owa-module-context-mailboxinfo/lib/selectors/getModuleContextMailboxInfo';
import { addinsHeader, addinsBody, addinsTitle } from '../AppPaneGroup.scss';
import type { FunctionComponent } from 'react';

function createAddinsHeader(mailboxInfo: any) {
    return <LazyAddinsFlexPaneHeader mailboxInfo={mailboxInfo} renderTaskPaneInPanel={true} />;
}

const defaultExport: FunctionComponent<{}> = observer(function AddinsPane() {
    const paneId = getDrawerPaneId('addins');
    const mailboxInfo = getModuleContextMailboxInfo();

    return (
        <DrawerPane
            paneId={paneId}
            headerText={createAddinsHeader(mailboxInfo)}
            headerClassName={addinsHeader}
            titleClassName={addinsTitle}
            bodyClassName={addinsBody}
            showCloseButton={false}
            preserveContentOnDismiss={true}
            role={'complementary'}
        >
            <LazyAddinsFlexPaneBody mailboxInfo={mailboxInfo} />
        </DrawerPane>
    );
}, 'AddinsPane');
export default defaultExport;
